/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import styled from 'styled-components';
import { TypographyComponent, Icon } from '@tvg/fuse-design';
import IconCheck from '@tvg/fuse-icons/lib/Check';
import IconClose from '@tvg/fuse-icons/lib/Close';

const FeatureBulletWrapper = styled.div`
  display: flex;
  justify-content: start;
`;

const FeatureBulletIcon = styled(Icon)`
  position: relative;
  bottom: 5px;
  margin-right: 10px;
  flex: 0 0 24px;
`;

interface Props {
  featureBullet: string;
  isCovered: boolean;
}

export function FeatureBullet({ featureBullet, isCovered }: Props) {
  return (
    <FeatureBulletWrapper>
      <FeatureBulletIcon
        color={isCovered ? 'var(--color-universal-greenMid)' : 'var(--color-universal-redMid)'}
        icon={isCovered ? <IconCheck /> : <IconClose />}
        title={isCovered ? 'covered' : 'not covered'}
        desc={isCovered ? 'green check' : 'red cross'}
        dataTestId={isCovered ? 'covered-insurance-icon' : 'not-covered-insurance-icon'}
        responsiveSize="medium"
        size="medium"
      />
      <TypographyComponent size="m1" tag="p" type="paragraph" dataTestId="insurance-bullet-description">
        {featureBullet}
      </TypographyComponent>
    </FeatureBulletWrapper>
  );
}

export default FeatureBullet;
